<template>
  <tr class="device-row">
    <td>
      <span
        class="icon fa-lg"
        :class="connected ? 'has-text-primary' : 'has-text-grey'"
        :title="$t(connectionLabel)"
      >
        <i class="fa fa-wifi" />
      </span>
    </td>
    <td>
      <input-field
        v-model="deviceName"
        @focus="deviceName_onFocus"
        :maxlength="21"
        :errors="deviceName_errorsIfDirty"
      />
    </td>
    <td>
      <button
        class="button is-primary is-outlined"
        :disabled="!deviceName_valid || !deviceName_dirty"
        @click="setDeviceName(device.id, deviceName)"
      >
        {{ $t("Save") }}
      </button>
    </td>
    <td>
      <button
        class="button is-danger is-outlined"
        @click="removeDevice(device.id)"
      >
        {{ $t("Remove") }}
      </button>
    </td>
    <td>
      <field-message
        v-if="successMsg || failureMsg"
        :success="$t(successMsg)"
        :failure="$t(failureMsg)"
      />
      <field-message
        v-if="connected"
        :failure="$t(warning)"
        style="margin-right: unset;"
      />
    </td>
  </tr>
</template>

<script>
import { InputField, FieldMessage } from "@/components/form"
import { validator, maxSize } from "@/validator"
import moment from "moment"

const DEVICE_WARNING_THRESHOLD = 60 * 1000

function validateDeviceTime(device) {
  const deviceTimeOffset = Math.abs(
    device.connected - device.connectedClientTime
  )
  if (deviceTimeOffset > DEVICE_WARNING_THRESHOLD) {
    return [
      "Device time is incorrect. {0} minutes difference",
      Math.round(deviceTimeOffset / DEVICE_WARNING_THRESHOLD)
    ]
  }
}

export default {
  name: "device-row",
  props: ["device", "deviceStatus", "failureMsg", "successMsg"],
  mixins: [validator],
  components: {
    InputField,
    FieldMessage
  },
  data() {
    return {
      deviceName: this.device.name
    }
  },
  validations: {
    deviceName: [maxSize(20)]
  },
  watch: {
    device() {
      this.deviceName_reset(this.device.name)
    }
  },
  computed: {
    connected() {
      return (
        this.deviceStatus &&
        this.deviceStatus.connected &&
        !this.deviceStatus.disconnected
      )
    },
    connectionLabel() {
      if (!this.deviceStatus) {
        return "Never connected"
      }
      if (this.connected) {
        return [
          "Connected since {0}",
          moment(this.deviceStatus.connected).format("DD.MM.YYYY HH:mm:ss")
        ]
      }
      return [
        "Disconnected since {0}",
        moment(this.deviceStatus.disconnected).format("DD.MM.YYYY HH:mm:ss")
      ]
    },
    warning() {
      return validateDeviceTime(this.deviceStatus)
    }
  },
  methods: {
    setDeviceName(deviceId, deviceName) {
      this.$emit("changeName", deviceId, deviceName)
    },
    removeDevice(deviceId) {
      this.$emit("delete", deviceId)
    }
  }
}
</script>

<style lang="scss">
.device-row {
  td {
    vertical-align: middle;
  }

  td:last-child {
    border: none;
  }
}
</style>
